// src/components/button/SheetSelector.tsx

import { FunctionsTwoTone, Star } from '@mui/icons-material'
import {
  ToggleButton,
  ToggleButtonGroup,
  Tooltip,
  Typography,
} from '@mui/material'

type Props = {
  colors: any
  data: string[]
  onChange: (index: number) => void
  title?: string
}

export const SheetSelector = ({ colors, data, onChange, title }: Props) => (
  <ToggleButtonGroup
    exclusive
    sx={{ ml: 2 }}
    value={title || 'Gesamtverbrauch'}
  >
    {data.map((item, key) => (
      <ToggleButton key={item} onClick={() => onChange(key)} value={item}>
        <Tooltip title={item}>
          {item === 'Gesamtverbrauch' ? (
            <FunctionsTwoTone />
          ) : (
            <Star sx={{ color: colors[item] }} />
          )}
        </Tooltip>

        {data.length <= 4 && (
          <Typography sx={{ fontSize: 14, ml: 1 }}>{item}</Typography>
        )}
      </ToggleButton>
    ))}
  </ToggleButtonGroup>
)
